import { getRequst, postRequest } from '.'
import type {
  IResponseType,
  IUserLoginParams,
  IUserInfoType,
  IResponsePageType,
  IPageQueryType,
  IAllDataDto,
  ImarkDetail,
  IBridgeData,
  ICameraData,
  INoticeData,
  IBridgeDeytail,
  IShipInfo,
  IrescueInfo,
  IwharfInfo,
  IsandbarInfo,
  IshipAll,
} from './types'

/** 获取验证码及UUID */
export const getCaptchaImage = () =>
  getRequst<
    IResponseType<null> & {
      img: string
      captchaEnabled: boolean
      uuid: string
    }
  >('/captchaImage')

/** 用户登录  */
export const userLogin = (param: IUserLoginParams) =>
  postRequest<{
    token: string
  }>('/login', param)

/**获取用户信息 */
export const getUserInfo = () =>
  getRequst<
    IResponseType<null> & {
      user: IUserInfoType
    }
  >('/getInfo')

/** 用户退出登录 */
export const userLogout = () => postRequest<IResponseType<null>>('/logout')

/** 获取全部点位信息 */
export const getAllDataInfo = (params: { name?: string } & IPageQueryType) =>
  getRequst<IResponsePageType<IAllDataDto[]>>('/navigation/get/all/data/info', params)

/**获取航标点位信息 */
export const getMarkDataInfo = (params: { name?: string } & IPageQueryType) =>
  getRequst<IResponsePageType<ImarkDetail[]>>('/navigation/mark/get/list', params)

/**获取桥梁点位坐标 */
export const getBridgeDataInfo = (params: { bridgeName?: string } & IPageQueryType) =>
  getRequst<IResponsePageType<IBridgeData[]>>('/bridge/data/all', params)

/**获取所有摄像头坐标 */
export const getCameraDataInfo = (params: { name?: string } & IPageQueryType) =>
  getRequst<IResponsePageType<ICameraData[]>>('/camera/list', params)

/**通告 */
export const getNoticeDataInfo = (
  params: { name?: string; startDate?: string; endDate?: string; isDate: boolean } & IPageQueryType
) => getRequst<IResponsePageType<INoticeData[]>>('/navigationNotice/list', params)

/**获取桥梁详情 */
export const getBridgeDataDetail = (params: { id: number }) =>
  getRequst<IResponseType<IBridgeDeytail>>('/bridge/data/detail', params)

/**获取监控详情 */
export const getCameraDetail = (params: { id: number }) =>
  getRequst<IResponseType<ICameraData>>('/camera/detail', params)

/**获取航标详情 */
export const getMarkDetail = (params: { id: number }) =>
  getRequst<IResponseType<ImarkDetail>>('/navigation/mark/get/detail', params)

/**获取船只点位信息 */
export const getShipDataInfo = (
  params: { name?: string; mmis?: string; type?: string } & IPageQueryType
) => getRequst<IResponsePageType<IShipInfo[]>>('/ship/get/list', params)



/**获取搜救站点位信息 */
export const getaisDataInfo = (params: { name?: string } & IPageQueryType) =>
  getRequst<IResponsePageType<IrescueInfo[]>>('/aidStation/get/list', params)

/** 获取搜救站详情*/
export const getaisDetail = (params: { id: number }) =>
  getRequst<IResponseType<IrescueInfo>>('/aidStation/get/detail', params)

/**获取码头详情列表 */
export const getwharfDataInfo = (params: { name?: string } & IPageQueryType) =>
  getRequst<IResponsePageType<IwharfInfo[]>>('/dock/get/list', params)

/** 获取搜救站详情*/
export const getwharfDetail = (params: { id: number }) =>
  getRequst<IResponseType<IwharfInfo>>('/dock/get/detail', params)

/**获取沙洲 */
export const getsandbarList = (params: { name?: string } & IPageQueryType) =>
  getRequst<IResponsePageType<IsandbarInfo[]>>('/sandbar/get/combined', params)

/**获取吉星船只 */
export const getjixingShipList=(params: { name?: string } & IPageQueryType) =>
  getRequst<any>('/ship/get/combined', params)

/**获取App船只 */
export const getappShipList=(params: { name?: string } & IPageQueryType) =>
  getRequst<any>('/ship/get/APP', params)

/**获取全部船只 */
export const getAllShipDataInfo = (
  params?: { name?: string; mmis?: string; type?: string } & IPageQueryType
) => getRequst<IResponsePageType<IshipAll[]>>('/ship/get/combinedData', params)